import { useEffect } from "react";
import CourseModuleInterface from "../../../Interfaces/CourseModuleInterface";
import ProgressScale from "../../UI/ProgressScale";

const CourseModule = ({
  id,
  className = "courseModule",
  moduleTitle,
  head,
  description,
  themesAmount,
  testsAmount,
  progress,
  max,
  fullCompletion,
  callback,
}: CourseModuleInterface) => {
  useEffect(() => {

    if (id && progress && max && progress / max >= 1) {
      fullCompletion({ id: id, complete: true });
    }
  }, [id, max, progress]);

  return (
    <div className={className} onClick={callback}>
      <div className="courseModuleContent">
        <div className="moduleNumber">{moduleTitle}</div>
        <h3 className="moduleName">{head}</h3>
        {description && <div className="moduleDesciption">{description}</div>}
      </div>
      <div className="moduleBottomBox">
        <div className="moduleAmountBox">
          {themesAmount && <p>Тем в модуле: {themesAmount}</p>}
          {/* {testsAmount && <p>Всего тестов: {testsAmount}</p>} */}
        </div>
        {progress ? (
          <ProgressScale scale={progress} max={max} className="moduleScale" />
        ) : null}
      </div>
    </div>
  );
};

export default CourseModule;
